import { gql } from '@apollo/client';
import type { OpdsAccountType } from './queryOpdsAccountByPage';

export const GET_OPDS_ACCOUNT_DETAIL_BY_ID = gql`
  query GetOpdsAccountDetailById($id: Long!) {
    getOpdsAccountDetailById(id: $id) {
      success
      message
      data {
        id
        email
        countryCode
        phone
        name
        role
        language
        status
        blacklist
        phoneStatus
        employed
        createdAt
        updatedAt
        deptIds
        roleIds
        larkId
      }
    }
  }
`;

export interface GetOpdsAccountDetailByIdResponse {
  getOpdsAccountDetailById: {
    success: boolean;
    message: string;
    data?: OpdsAccountType | null;
  };
}

export interface GetOpdsAccountDetailByIdVariables {
  id: number;
}
